<template>
  <div>
    <Simulation
      :simulationDevices="simulationDevices"
      :busConfigurations="busConfigurations"
      simulationLabel="SolarControllersAustraliaDeltaSolSll_1d00_P10"
    >
    </Simulation>
  </div>
</template>

<script>
import Simulation from '@/components/Simulation';
import SolarControllersAustraliaDeltaSolSll_1d00 from '@/device-products/SolarControllersAustraliaDeltaSolSll_1d00_P10.vue';

export default {
  components: {
    Simulation,
  },

  data: () => ({
    busConfigurations: [
      {
        label: 'GP', connections: [
        ],
      },
    ],
    simulationDevices: [
      { id: 0, component: SolarControllersAustraliaDeltaSolSll_1d00, deviceLabel: null },
    ],
  }),
};
</script>

<style>

</style>
